// Imports
import { faShield, faEdit, faUser, faLock, faEnvelope, faStar } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { useLocation } from 'react-router-dom';
import PageTitle from '../../shared-components/page-title';
import PageAction from '../shared-components/page-action';
import PageActions from '../shared-components/page-actions';
import useMemberCheck from '../../../../../../utils/use-member-check';


// Function component
const TopPortion: React.FC = () => {
	// Use Redux functionality
	const isAdmin = useMemberCheck({ type: 'ANY_PRIVILEGE' });
	
	
	// Use React Router functionality
	const location = useLocation();
	
	
	// Return JSX
	return (
		<React.Fragment>
			<PageTitle>Member settings</PageTitle>
			
			<PageActions>
				<PageAction
					icon={faEdit}
					text='General'
					to='general'
					color={location.pathname.split('/').pop() === 'general' ? 'primary' : 'plain'}
					inverted={location.pathname.split('/').pop() !== 'general'}
					data-intercom-target='page-action-general'
					replace
				/>
				
				<PageAction
					icon={faUser}
					text='Profile'
					to='profile'
					color={location.pathname.split('/').pop() === 'profile' ? 'primary' : 'plain'}
					inverted={location.pathname.split('/').pop() !== 'profile'}
					data-intercom-target='page-action-profile'
					replace
				/>
				
				<PageAction
					icon={faLock}
					text='Password'
					to='password'
					color={location.pathname.split('/').pop() === 'password' ? 'primary' : 'plain'}
					inverted={location.pathname.split('/').pop() !== 'password'}
					data-intercom-target='page-action-password'
					replace
				/>
				
				<PageAction
					icon={faEnvelope}
					text='Contact'
					to='contact'
					color={location.pathname.split('/').pop() === 'contact' ? 'primary' : 'plain'}
					inverted={location.pathname.split('/').pop() !== 'contact'}
					data-intercom-target='page-action-contact'
					replace
				/>
				
				<PageAction
					icon={faShield}
					text='Privacy'
					to='privacy'
					color={location.pathname.split('/').pop() === 'privacy' ? 'primary' : 'plain'}
					inverted={location.pathname.split('/').pop() !== 'privacy'}
					data-intercom-target='page-action-privacy'
					replace
				/>
				
				{isAdmin && (
					<PageAction
						icon={faStar}
						text='Admin'
						to='admin'
						color={location.pathname.split('/').pop() === 'admin' ? 'primary' : 'plain'}
						inverted={location.pathname.split('/').pop() !== 'admin'}
						data-intercom-target='page-action-admin'
						replace
					/>
				)}
			</PageActions>
		</React.Fragment>
	);
};

export default TopPortion;
